import React from 'react'; 
import Block from '@legacy-vfuk/core-block';
import Heading from '@legacy-vfuk/core-heading';
import RichTextElement from '../../Elements/RichText';
import { SectionConfirmationContentProps } from './types/SectionConfirmationContent.types';
import {
  BlockWrapper,
  BodyHeaderWrapper,
  BodyRichTextWrapper,
  HeaderWrapper,
  IconWrapper,
  SubheaderWrapper
} from './styles/SectionConfirmationContent.styles';
import Icon from '@legacy-vfuk/core-icon';

const SectionConfirmationContent = ({
  header,
  subheader,
  bodyHeader,
  bodyRichText,
  iconRef
}: SectionConfirmationContentProps) => {
  return (
    <BlockWrapper>
      <Block>
        <HeaderWrapper>
          <Heading size={4} weight={3} text={header} />
        </HeaderWrapper>
        <SubheaderWrapper>
          <Heading size={4} weight={2} text={subheader} />
        </SubheaderWrapper>
        <BodyHeaderWrapper>
          <Heading size={3} weight={3} text={bodyHeader} />
        </BodyHeaderWrapper>
        <BodyRichTextWrapper>
          <RichTextElement
            key={bodyRichText.id}
            text={bodyRichText.text}
            color={bodyRichText.color}
            textAlign={bodyRichText.textAlign}
          />
        </BodyRichTextWrapper>
        {iconRef && (
          <IconWrapper>
            <Icon name={iconRef} size={5} />
          </IconWrapper>
        )}
      </Block>
    </BlockWrapper>
  );
};

export default SectionConfirmationContent;
